import { render } from "./LayoutDiv.vue?vue&type=template&id=b2d64360"
import script from "./LayoutDiv.vue?vue&type=script&lang=js"
export * from "./LayoutDiv.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__